import { TreeOfNodes } from "@asup/tree-of-nodes";
import { hierarchyToNodes } from "components/hierarchybrowser/hierarchyToNodes";
import { useHierarchyContext } from "contexts/AppSettingsContext";
import { useUnsavedChanges } from "contexts/UnsavedChangesContextProvider";
import { eAccessRights, eHierarchyLevel } from "functions/api/enums";
import { Key } from "react";
import { AddHierarchyButton } from "./AddHierarchyButton";

/**
 * Navigation tree for Study and report levels.
 * Effectively static as nodes should always be expanded.
 */
export const StudyTree: React.FC = () => {
  const hierarchyContext = useHierarchyContext();
  const navigate = useUnsavedChanges("study-tree").navigate;

  const showStudyTree =
    hierarchyContext?.hierarchy?.level === eHierarchyLevel.Study ||
    hierarchyContext?.hierarchy?.level === eHierarchyLevel.Report;
  const studyHierarchy =
    hierarchyContext?.hierarchy?.level === eHierarchyLevel.Report
      ? hierarchyContext?.hierarchyNodes.find((h) => h.id === hierarchyContext?.hierarchy?.parentId)
      : hierarchyContext?.hierarchy;

  const nodeList = studyHierarchy ? hierarchyToNodes([studyHierarchy]) : null;

  /**
   * Handle click on a node in the study tree.
   *
   * @param ret - The selected node ID(s)
   */
  const handleSelect = (ret: Key | Key[]) => {
    const node = nodeList?.find((n) => n.id === ret);
    /* istanbul ignore else */
    if (node?.data) {
      navigate(node.data.url);
    }
  };

  return !studyHierarchy || !showStudyTree || !nodeList ? null : (
    <>
      <TreeOfNodes
        id="study-tree"
        handleSelect={handleSelect}
        initiallyExpandedNodes={[studyHierarchy.id]}
        nodeHighlight="rgb(0,0,0)"
        nodeList={nodeList}
        roots={[studyHierarchy.id]}
        selected={hierarchyContext.hierarchy!.id}
        textHighlight="rgba(33,35,211,0.1)"
      />
      {hierarchyContext?.accessRights.includes(eAccessRights.CreateHierarchy) && (
        <AddHierarchyButton key={studyHierarchy.id} />
      )}
      <hr />
    </>
  );
};

StudyTree.displayName = "StudyTree";
